const maxCapacityByEvent = {
  213481: {
    maxCapacity: 9,
    zones: {
      2: 3,
    },
  },
  213634: {
    maxCapacity: 30,
    zones: {
      taller: 8,
      general: 22,
    },
  },
};
const maxCapacityByUser = {
  2326245: {
    maxCapacity: 9,
    zones: {
      boleto: 3,
    },
  },
};

const getData = (userID, eventID) => {
  if (maxCapacityByUser[userID]) {
    return maxCapacityByUser[userID];
  } else if (maxCapacityByEvent[eventID]) {
    return maxCapacityByEvent[eventID];
  }
  return null;
};

const getZone = (userID, eventID, ticketName) => {
  const data = getZoneData(userID, eventID, ticketName);
  if (data) {
    return data.id;
  }
  return null;
};

const getZoneData = (userID, eventID, ticketName) => {
  const data = getData(userID, eventID);
  if (data) {
    const zone = Object.keys(data.zones).find((zoneKey) => {
      return ticketName.toLowerCase().includes(zoneKey.toLowerCase());
    });
    return zone ? { id: zone, max: data.zones[zone] } : null;
  }
  return null;
};

export { getData, getZone, getZoneData };
